import styled from "styled-components";

export const Card = styled.div`
    width: 100%;
    max-width: 380px;

    height: 100%;
    max-height: 420px;

    background: #ffffff;
    border: 1px solid #d6d6d6;
    border-radius: 16px;

    overflow: visible;
    box-sizing: border-box;

    justify-self: stretch;
    align-self: stretch;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;

    .ui.dropdown {
        min-width: auto;
    }

    .ellipsis.icon {
        margin: 0;
        cursor: pointer;
        color: #6a7282;
    }
`;

export const Title = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: #101828;
`;

export const Subtitle = styled.div`
    font-size: 12px;
    color: #6a7282;
`;

export const GatewayId = styled.div`
    font-size: 12px;
    color: #99a1af;
    font-style: italic;
`;

export const TooltipWrapper = styled.div`
    position: relative;
    width: fit-content;
    cursor: default;

    &:hover > div:last-child {
        opacity: 1;
        visibility: visible;
    }
`;

export const Tooltip = styled.div`
    position: absolute;
    right: 0;
    bottom: calc(100% + 8px);
    width: max-content;
    max-width: 280px;
    padding: 10px;
    background: #333;
    border-radius: 4px;
    color: #fff;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
    pointer-events: none;
    z-index: 1000;

    &::after {
        content: "";
        position: absolute;
        bottom: -12px;
        right: 12px;
        border-width: 6px;
        border-style: solid;
        border-color: #333 transparent transparent transparent;
    }
`;

export const Divider = styled.div`
    border-top: 1px solid #ebebeb;
`;

export const Footer = styled.div`
    padding: 12px 16px;
`;
